import { OTHER_DETAILS } from 'common/application.const/Licence/MyLicence/expressLetter';
import { LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/cancel-AircraftApplication';
import commonPayload from '../common';
import {
    VENDOR_INFORMATION,
    VENDOR_ADDRESS,
    LAND_FIXED_STATION,
    STATION_DETAILS,
    PROPOSED_USE,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/LPNLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatLPNMultiChannel = async (licenceDetails: any) => {
    let licence;
    const billingData = commonPayload.getBillingData(licenceDetails);
    const contactPersonParticulars = commonPayload.getContactPersonParticulars(licenceDetails);
    const billingPersonParticulars = commonPayload.getBillingPersonParticulars(licenceDetails);

    licence = {
        id: 'localised-details',
        formID: 'localised-details',
        hasError: true,
        title: 'Application Details',
        values: {
            ...contactPersonParticulars,
            ...billingPersonParticulars,
            ...billingData,
            [`${OTHER_DETAILS}-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEgCraneOperationSecurityServices ?? '-',
            [`${LICENCE_DETAILS}-postal-no`]: licenceDetails?.networkInformation?.operatingAddress.postalCode ?? '-',
            [`${LICENCE_DETAILS}-block-no`]: licenceDetails?.networkInformation?.operatingAddress.blockno ?? '-',
            [`${LICENCE_DETAILS}-street-name`]: licenceDetails?.networkInformation?.operatingAddress.streetName ?? '-',
            [`${LICENCE_DETAILS}-building-name`]: licenceDetails?.networkInformation?.operatingAddress.buildingName ?? '-',
            [`${LICENCE_DETAILS}-floor`]: licenceDetails?.networkInformation?.operatingAddress.floor ?? '-',
            [`${LICENCE_DETAILS}-unit`]: licenceDetails?.networkInformation?.operatingAddress.unit ?? '-',
            [`${LICENCE_DETAILS}-lat-deg`]: licenceDetails?.networkInformation?.latitudeDegrees ?? '-',
            [`${LICENCE_DETAILS}-lat-min`]: licenceDetails?.networkInformation?.latitudeMinutes ?? '-',
            [`${LICENCE_DETAILS}-lat-sec`]: licenceDetails?.networkInformation?.latitudeSeconds ?? '-',
            [`${LICENCE_DETAILS}-lon-deg`]: licenceDetails?.networkInformation?.longitudeDegrees ?? '-',
            [`${LICENCE_DETAILS}-lon-minutes`]: licenceDetails?.networkInformation?.longitudeMinutes ?? '-',
            [`${LICENCE_DETAILS}-lon-sec`]: licenceDetails?.networkInformation?.longitudeSeconds ?? '-',
            [`${LICENCE_DETAILS}-manufacturer`]: licenceDetails?.portablesInformation?.manufacturer ?? '-',
            [`${LICENCE_DETAILS}-model`]: licenceDetails?.portablesInformation?.model ?? '-',
            [`${LICENCE_DETAILS}-num-of-portables`]: licenceDetails?.portablesInformation?.numberOfPortables ?? '-'
        }
    };

    return licence;
};

export const formatLPN = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence,
        newDocs = [],
        newPayload,
        docsLic,
        desiredfrequencyInformation = [],
        portableInformation = [],
        landFixedStationDetails = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    const billingData = commonPayload.getBillingData(licenceDetails);
    const contactPersonParticulars = commonPayload.getContactPersonParticulars(licenceDetails);
    const billingPersonParticulars = commonPayload.getBillingPersonParticulars(licenceDetails);

    if (
        licenceDetails &&
        licenceDetails.networkInformation &&
        licenceDetails.networkInformation.desiredFrequency &&
        licenceDetails.networkInformation.desiredFrequency.length > 0
    ) {
        desiredfrequencyInformation = licenceDetails?.networkInformation.desiredFrequency?.map(
            (value: Record<string, string>, index: number) => ({
                'desired-frequency-mhz-from-tx': value?.assignedFrequencyMHzFromTransmit ?? '-',
                'desired-frequency-mhz-to-tx': value?.assignedFrequencyMHzToTransmit ?? '-',
                'desired-frequency-mhz-from-rx': value?.assignedFrequencyMHzFromReceive ?? '-',
                'desired-frequency-mhz-to-rx': value?.assignedFrequencyMHzToReceive ?? '-',
                'desired-bandwidth-khz-tx': value?.AssignedBandwidthTx ?? '-',
                'desired-bandwidth-khz-rx': value?.AssignedBandwidthRx ?? '-',
                'start-time': value?.startTime ?? '-',
                'stop-time': value?.stopTime ?? '-',
                'emission-class': value?.emissionClass ?? '-',
                'emission-class-transmit': value?.emissionClassTransmit ?? '-',
                'output-power-required-werp': value?.outputPowerRequiredWerp ?? '-',
                power: value?.Power ?? '-',
                'power-unit': value?.PowerUnit ?? '-'
            })
        );
    }

    if (licenceDetails && licenceDetails.PortablesInformationDetails && licenceDetails.PortablesInformationDetails.length > 0) {
        portableInformation = licenceDetails?.PortablesInformationDetails?.map((value: Record<string, string>, index: number) => ({
            no: value?.rowId ?? '-',
            manufacturer: value?.manufacturer ?? '-',
            model: value?.model ?? '-',
            'number-of-portable-stations': value?.numberOfPortableStationS ?? '-'
        }));
    }

    if (licenceDetails && licenceDetails.landFixedStationDetails && licenceDetails.landFixedStationDetails.length > 0) {
        landFixedStationDetails = licenceDetails?.landFixedStationDetails
            ?.map((value: any, index: number) => ({
                'station-name': value?.stationName ?? '-',
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'station-type': value?.stationType ?? '-',
                'building-name-optional': value?.operatingAddress?.buildingName ?? '-',
                'postal-code': value?.operatingAddress?.postalCode ?? '-',
                'street-name': value?.operatingAddress?.streetName ?? '-',
                'block-house-no': value?.operatingAddress?.blockNo ?? '-',
                'unit-optional': value?.operatingAddress?.unit ?? '-',
                'floor-level-optional': value?.operatingAddress?.floor ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'building-height-m': value?.buildingHeightM ?? '-',
                'antenna-structure-height-m': value?.antennaStructureHeightM ?? '-',
                'elevation-angle-above-mean-sea-level-m': value?.elevationAboveMeanSeaLevelM ?? '-',
                'coverage-radius-link-distance-km': value?.coverageRadiusLinkDistanceKm ?? '-',
                transportable: value?.transportable ?? '-',
                'feeder-line-transmit-type': value?.feederLineTransmitType ?? '-',
                'feeder-line-receive-type': value?.feederLineReceiveType ?? '-',
                'transmit-length-in-m': value?.transmitLengthInM ?? '-',
                'receive-length-in-m': value?.receiveLengthInM ?? '-',
                'transmit-loss-in-db': value?.transmitLossInDB ?? '-',
                'received-loss-in-db': value?.receivedLossInDB ?? '-',
                'system-emission-power-w': value?.systemEmissionPowerW ?? '-',
                'system-emission-power-type-werp-or-weirp': value?.systemEmissionPowerTypeWerpOrWeirp ?? '-',
                'transmitter-manufacturer': value?.transmitterManufacturer ?? '-',
                'transmitter-model': value?.transmitterModel ?? '-',
                'transmitter-power-w': value?.transmitterPowerW ?? '-',
                'receiver-manufacturer': value?.receiverManufacturer ?? '-',
                'receiver-model': value?.receiverModel ?? '-',
                'antenna-manufacturer': value?.antennaManufacturer ?? '-',
                'antenna-model': value?.antennaModel ?? '-',
                'antenna-effective-height-m-above-ground-level': value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
                'gain-db': value?.gainDB ?? '-',
                'elevation-angle': value?.elevationAngle ?? '-',
                'filter-manufacturer': value?.filterManufacturer ?? '-',
                'filter-model': value?.filterModel ?? '-',
                'insertion-loss-db': value?.insertionLossDB ?? '-',
                'tuned-frequency-mhz': value?.tunedFrequencyMHz ?? '-',
                polarization: value?.polarization ?? '-',
                'frequency-and-emission-class-information':
                    value?.frequencyAndEmissionClassInformation.map((i: any) => {
                        return {
                            'desired-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.AssignedBandwidthTx ?? '-',
                            'desired-bandwidth-khz-rx': i.AssignedBandwidthRx ?? '-',
                            'emission-class': i.emissionClass ?? '-',
                            power: i.Power ?? '-',
                            'power-unit': i.PowerUnit ?? '-',
                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`station-name-${index}`]: item['station-name'],
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`station-type-${index}`]: item['station-type'],
                    [`building-name-optional${index}`]: item['building-name-optional'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`unit-optional${index}`]: item['unit-optional'],
                    [`floor-level-optional${index}`]: item['floor-level-optional'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`building-height-m-${index}`]: item['building-height-m'],
                    [`antenna-structure-height-m-${index}`]: item['antenna-structure-height-m'],
                    [`elevation-angle-above-mean-sea-level-m-${index}`]: item['elevation-angle-above-mean-sea-level-m'],
                    [`coverage-radius-link-distance-km-${index}`]: item['coverage-radius-link-distance-km'],
                    [`transportable-${index}`]: item['transportable'],
                    [`feeder-line-transmit-type-${index}`]: item['feeder-line-transmit-type'],
                    [`feeder-line-receive-type-${index}`]: item['feeder-line-receive-type'],
                    [`transmit-length-in-m-${index}`]: item['transmit-length-in-m'],
                    [`receive-length-in-m-${index}`]: item['receive-length-in-m'],
                    [`transmit-loss-in-db-${index}`]: item['transmit-loss-in-db'],
                    [`received-loss-in-db-${index}`]: item['received-loss-in-db'],
                    [`system-emission-power-w-${index}`]: item['system-emission-power-w'],
                    [`system-emission-power-type-werp-or-weirp-${index}`]: item['system-emission-power-type-werp-or-weirp'],
                    [`transmitter-manufacturer-${index}`]: item['transmitter-manufacturer'],
                    [`transmitter-model-${index}`]: item['transmitter-model'],
                    [`transmitter-power-w-${index}`]: item['transmitter-power-w'],
                    [`receiver-manufacturer-${index}`]: item['receiver-manufacturer'],
                    [`receiver-model-${index}`]: item['receiver-model'],
                    [`antenna-manufacturer-${index}`]: item['antenna-manufacturer'],
                    [`antenna-model-${index}`]: item['antenna-model'],
                    [`antenna-effective-height-m-above-ground-level-${index}`]: item['antenna-effective-height-m-above-ground-level'],
                    [`gain-db-${index}`]: item['gain-db'],
                    [`elevation-angle-${index}`]: item['elevation-angle'],
                    [`filter-manufacturer-${index}`]: item['filter-manufacturer'],
                    [`filter-model-${index}`]: item['filter-model'],
                    [`insertion-loss-db-${index}`]: item['insertion-loss-db'],
                    [`tuned-frequency-mhz-${index}`]: item['tuned-frequency-mhz'],
                    [`polarization-${index}`]: item['polarization'],
                    [`frequency-and-emission-class-information-${index}`]: item['frequency-and-emission-class-information']
                };
            });
    }

    licence = {
        id: 'localised-private',
        formID: 'localised-private',
        hasError: true,
        title: 'Licence Details',
        values: {
            ...contactPersonParticulars,
            ...billingPersonParticulars,
            ...billingData,

            [`${PROPOSED_USE}-proposed-use`]: licenceDetails?.vendorInformation?.proposedUsed ?? '-',

            [`${VENDOR_INFORMATION}-company-name`]: licenceDetails?.vendorInformation?.CompanyNameJson ?? '-',
            [`${VENDOR_INFORMATION}-vendors-dealers-licence-number`]: licenceDetails?.vendorInformation?.vendorSDealerSLicenceNumber ?? '-',
            [`${VENDOR_INFORMATION}-contact-person`]: licenceDetails?.vendorInformation?.contactPersonName ?? '-',
            [`${VENDOR_INFORMATION}-contact-number-optional`]: licenceDetails?.vendorInformation?.ContactNumber ?? '-',
            [`${VENDOR_INFORMATION}-email`]: licenceDetails?.vendorInformation?.email ?? '-',

            [`${VENDOR_ADDRESS}-building-name`]: licenceDetails?.vendorInformation?.address?.buildingName ?? '-',
            [`${VENDOR_ADDRESS}-postal-code`]: licenceDetails?.vendorInformation?.address?.postalCode ?? '-',
            [`${VENDOR_ADDRESS}-street-name`]: licenceDetails?.vendorInformation?.address?.streetName ?? '-',
            [`${VENDOR_ADDRESS}-block-house-no`]: licenceDetails?.vendorInformation?.address?.blockNo ?? '-',
            [`${VENDOR_ADDRESS}-unit`]: licenceDetails?.vendorInformation?.address?.unit ?? '-',
            [`${VENDOR_ADDRESS}-floor-level`]: licenceDetails?.vendorInformation?.address?.floor ?? '-',

            [`${LAND_FIXED_STATION}-any-land-fixed-station`]: licenceDetails?.landFixedStation?.anyLandFixedStation ?? '-',

            [`${STATION_DETAILS}-station-tabs`]: [
                { 'network-details': [] },
                { 'land-fixed-station-details': [...landFixedStationDetails] },
                { 'mobile-portable-details': [] }
            ],

            [`do-you-have-the-postal-code`]: licenceDetails?.networkInformation?.doYouHaveThePostalCode ?? '-',

            [`building-name`]: licenceDetails?.networkInformation?.operatingAddress?.buildingName ?? '-',
            [`postal-code`]: licenceDetails?.networkInformation?.operatingAddress?.postalCode ?? '-',
            [`street-name`]: licenceDetails?.networkInformation?.operatingAddress?.streetName ?? '-',
            [`block-house-no`]: licenceDetails?.networkInformation?.operatingAddress?.blockNo ?? '-',
            [`unit-optional`]: licenceDetails?.networkInformation?.operatingAddress?.unit ?? '-',
            [`floor-level-optional`]: licenceDetails?.networkInformation?.operatingAddress?.floor ?? '-',
            [`do-you-have-the-mukim-or-land-lot-number`]: licenceDetails?.networkInformation?.doYouHaveTheMukimOrLandLotNumber ?? '-',
            [`mukim-land-lot-number`]: licenceDetails?.networkInformation?.mukimLandLotNumber ?? '-',

            [`latitude-degrees`]: licenceDetails?.networkInformation?.latitudeDegrees ?? '-',
            [`latitude-minutes`]: licenceDetails?.networkInformation?.latitudeMinutes ?? '-',
            [`latitude-seconds`]: licenceDetails?.networkInformation?.latitudeSeconds ?? '-',
            [`longitude-degrees`]: licenceDetails?.networkInformation?.longitudeDegrees ?? '-',
            [`longitude-minutes`]: licenceDetails?.networkInformation?.longitudeMinutes ?? '-',
            [`longitude-seconds`]: licenceDetails?.networkInformation?.longitudeSeconds ?? '-',

            [`number-of-frequencies-required`]: licenceDetails?.networkInformation?.numberOfFrequencyIesRequired ?? '-',
            [`desired-frequency-information`]: desiredfrequencyInformation ?? [...desiredfrequencyInformation],
            [`portables-information`]: portableInformation ?? [...portableInformation],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const lpnPayload = {
    formatLPNMultiChannel,
    formatLPN
};

export default lpnPayload;
